import { render, staticRenderFns } from "./NetworkStatistics.vue?vue&type=template&id=3ed37174&"
import script from "./NetworkStatistics.vue?vue&type=script&lang=js&"
export * from "./NetworkStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports